import { Box, Paper, Typography } from '@mui/material';
import { ExternalLink } from 'lucide-react';

function PartnerCard({ partner }) {
  if (!partner?.name) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, sm: 4 },
        mx: 'auto',
        maxWidth: 560,
        mb: { xs: 5, sm: 7, md: 9 },
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(74, 106, 74, 0.15)',
        borderRadius: 3,
        textAlign: 'center',
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          color: 'primary.main',
          letterSpacing: '0.22em',
          fontWeight: 600,
          fontSize: '0.72rem',
          mb: 2,
        }}
      >
        En alianza con
      </Typography>
      {partner.logo && (
        <Box
          component="img"
          src={partner.logo}
          alt={partner.name}
          sx={{
            height: { xs: 44, sm: 52 },
            width: 'auto',
            mx: 'auto',
            mb: 1.5,
            opacity: 0.85,
          }}
        />
      )}
      <Typography
        sx={{
          fontFamily: 'var(--font-heading)',
          color: 'text.primary',
          fontSize: { xs: '1.35rem', sm: '1.55rem' },
          fontWeight: 500,
          lineHeight: 1.25,
        }}
      >
        {partner.name}
      </Typography>
      {partner.tagline && (
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.95rem',
            mt: 0.75,
          }}
        >
          {partner.tagline}
        </Typography>
      )}
      {partner.website && (
        <Box
          component="a"
          href={partner.website}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.75,
            mt: 2,
            color: 'primary.main',
            textDecoration: 'none',
            fontWeight: 600,
            fontSize: '0.9rem',
            minHeight: 44,
            px: 1,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          Visitar sitio
          <ExternalLink size={14} />
        </Box>
      )}
    </Paper>
  );
}

export default PartnerCard;
